import React from "react";
import SelectReturnproduct from "../Components/OrderDetails/SelectReturnproduct";
import Breadcrumb from "../Components/Breadcrumb";
import SpecialProducts from "../Components/Productdetails/SpecialProducts";
import { useEffect } from 'react';
function SelectReturnproductpage() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
      <Breadcrumb list1="Your Account" list2="Orders" list3="Order Details" />
      <SelectReturnproduct />
      <SpecialProducts />
    </>
  );
}

export default SelectReturnproductpage;
